module.exports = __webpack_public_path__ + "static/16-159b2f6f59d2685702829a7d60909b77.jpg";